import { Link } from "react-router-dom";
import HelmetTags from "./HelmetTags";
import logoLight from "../assets/logo-light.png";

function NotFound() {
  return (
    <section className="flex min-h-screen w-full flex-col items-center justify-center px-6 py-16">
      <HelmetTags
        title="404 | Page Not Found | Mr Ahmed Sabry"
        description="This page does not exist. Please return to the home page."
      />

      <Link className="h-48 w-auto" to="/">
        <img className="h-full" src={logoLight} alt="Mr Ahmed Sabry" />
      </Link>

      <div className="mt-10 flex w-full max-w-[450px] flex-col items-center rounded-3xl bg-white p-16 text-center shadow-3xl sm:w-3/4 sm:p-10">
        <p className="text-7xl font-bold text-[#4A9DEC]">404</p>
        <h1 className="mt-4 text-3xl font-bold">Page Not Found</h1>
        <p className="mt-3 text-[15px] opacity-80">
          This page does not exist. Please return to the home page or create an
          account.
        </p>

        <div className="mt-10 flex w-full flex-col items-center gap-4">
          <Link
            to="/"
            className="submit flex max-w-60 items-center justify-center bg-[#4A9DEC] text-white"
          >
            Back to Home
          </Link>
          <Link
            to="/signin"
            className="text-[14px] font-bold underline underline-offset-4"
          >
            Sign in
          </Link>
          <div className="flex flex-wrap items-center justify-center gap-3 text-[14px]">
            <Link className="font-bold" to="/register/national">
              Register for National
            </Link>
            <span className="text-gray-400">|</span>
            <Link className="font-bold" to="/register/ig">
              Register for IG
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NotFound;
